import React from 'react'
import Header1 from '../components/Header1'
import Footer from '../components/Footer'
import TechnographicsIsTheSecretIngredient from '../components/TechnographicsIsTheSecretIngredient'

export default function WhyTechnographicsIsTheSecretIngredientToPrecisionMessaging() {
  return (
    <div>
      <Header1/>
      <TechnographicsIsTheSecretIngredient/>
      <Footer/>
    </div>
  )
}
